import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomeIcon from './components/HomeIcon';
import Layout from './components/Layout';
import BottomNavigation from './components/BottomNavigation';
import ServiceWorkerUpdateAlert from './components/ServiceWorkerUpdateAlert';
import VersionUpdateAlert from './components/VersionUpdateAlert';
import InstallPrompt from './components/InstallPrompt';
import KillSwitch from './components/KillSwitch';
import Footer from './components/Footer';
import HomePage from './screens/HomePage';
import GuidePage from './screens/GuidePage';
import SetupWizard from './screens/SetupWizard';
import MatchSchedule from './screens/MatchSchedule';
import ScoreKeeper from './screens/ScoreKeeper';
import RoundRobinTable from './screens/RoundRobinTable';
import EliminationBracket from './screens/EliminationBracket';
import FinalRankingPage from './screens/FinalRankingPage';
import DebugAssalti from './screens/DebugAssalti';
import CompetitionTypeSelection from './screens/CompetitionTypeSelection';
import IndividualCompetitionConfig from './screens/IndividualCompetitionConfig';
import ConfigMiste from './screens/ConfigMiste';
import DebugDataFlow from './screens/DebugDataFlow';
import DebugGenerazione from './screens/DebugGenerazione';
import DebugPanel from './screens/DebugPanel';
import ToolPage from './screens/ToolPage';
import ScoreToolPage from './screens/tools/ScoreToolPage';
import LoggerToolPage from './screens/tools/LoggerToolPage';
import IntervalTimerToolPage from './screens/tools/IntervalTimerToolPage';
import VideoArbitraggioTool from './screens/tools/VideoArbitraggioTool';
import PlasmicExample from './components/PlasmicExample';
import './App.css';

function App() {
  return (
    <KillSwitch>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', width: '100%', overflow: 'hidden', margin: 0, padding: 0 }}>
        <HomeIcon />
        <ServiceWorkerUpdateAlert />
        <VersionUpdateAlert />
        <InstallPrompt />
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/guida" element={<GuidePage />} />
            <Route path="/genera" element={<CompetitionTypeSelection />} />
            <Route path="/config-squadre" element={<SetupWizard />} />
            <Route path="/config-individuale" element={<IndividualCompetitionConfig />} />
            <Route path="/config-miste" element={<ConfigMiste />} />
            <Route path="/schedule" element={<MatchSchedule />} />
            <Route path="/score" element={<ScoreKeeper />} />
            <Route path="/table" element={<RoundRobinTable />} />
            <Route path="/bracket" element={<EliminationBracket />} />
            <Route path="/final-ranking" element={<FinalRankingPage />} />
            <Route path="/debug" element={<DebugAssalti />} />
            <Route path="/debug-data" element={<DebugDataFlow />} />
            <Route path="/debug-generazione" element={<DebugGenerazione />} />
            <Route path="/debug-panel" element={<DebugPanel />} />
            <Route path="/tools" element={<ToolPage />} />
            <Route path="/tools/segnapunti" element={<ScoreToolPage />} />
            <Route path="/tools/logger" element={<LoggerToolPage />} />
            <Route path="/tools/timer" element={<IntervalTimerToolPage />} />
            <Route path="/tools/video-arbitraggio" element={<VideoArbitraggioTool />} />
            <Route path="/plasmic" element={<PlasmicExample />} />
          </Routes>
        </Layout>
        <Footer />
        <BottomNavigation />
      </div>
    </KillSwitch>
  );
}

export default App;

